import { capitalize } from 'lodash'
import { enGB, pl } from 'date-fns/locale'
import { currentLanguage } from '../locales'

export const getMonthName = (monthIndex: number): string => {
  const locale = currentLanguage === 'pl' ? pl : enGB

  return capitalize(locale.localize.month(monthIndex, { width: 'wide' }))
}
